import React from 'react';
import { Loader } from 'semantic-ui-react';

// Thin wrapper around Semantic UI's Loader so the rest of the feature can
// stay free of direct `semantic-ui-react` imports. A future migration off
// SUI (Tailwind / Radix / Headless) replaces the body of this file; no
// changes are needed at the call sites.

export type CmLoaderSize = 'mini' | 'tiny' | 'small' | 'medium' | 'large';

export interface CmLoaderProps {
  active?: boolean;
  inline?: boolean;
  size?: CmLoaderSize;
  testId?: string;
}

export function CmLoader({
  active = true,
  inline = true,
  size,
  testId,
}: CmLoaderProps): React.ReactElement {
  // SUI's Loader prop `inline` accepts true/false/'centered'. We expose just
  // the boolean here — inline is what every caller in this feature wants.
  return (
    <Loader active={active} inline={inline} size={size} data-testid={testId} />
  );
}

export default CmLoader;
